import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import {
  NgbDropdownModule,
  NgbNavModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { SimplebarAngularModule } from 'simplebar-angular';
// import { LanguageService } from '../core/services/language.service';
import { TranslateModule } from '@ngx-translate/core';

// Component pages
import { LayoutComponent } from './layout.component';
import { VerticalComponent } from './vertical/vertical.component';
import { TopbarComponent } from './topbar/topbar.component';
import { ImpersonationModalComponent } from './topbar/impersonation-modal/impersonation-modal.component';
import { AgencyContextSelectorComponent } from './topbar/agency-context-selector/agency-context-selector.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FooterComponent } from './footer/footer.component';
import { RightsidebarComponent } from './rightsidebar/rightsidebar.component';
import { HorizontalComponent } from './horizontal/horizontal.component';
import { HorizontalTopbarComponent } from './horizontal-topbar/horizontal-topbar.component';
import { TwoColumnComponent } from './two-column/two-column.component';
import { SharedModule } from '../shared/shared.module';
import { MenuService } from '../core/services/menu.service';
import { MomentModule } from 'ngx-moment';
import { PropertiesModule } from '../pages/properties/properties.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { ChatLauncherModule } from '../pages/chat/launcher/chat-launcher.module';

@NgModule({
  declarations: [
    LayoutComponent,
    VerticalComponent,
    TopbarComponent,
    ImpersonationModalComponent,
    AgencyContextSelectorComponent,
    SidebarComponent,
    FooterComponent,
    RightsidebarComponent,
    HorizontalComponent,
    HorizontalTopbarComponent,
    TwoColumnComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbDropdownModule,
    NgbNavModule,
    SimplebarAngularModule,
    TranslateModule,
    SharedModule,
    MomentModule,
    PropertiesModule,
    NgSelectModule,
    FormsModule,
    NgbTooltipModule,
    // Balão flutuante do chat em todas as páginas (ChatCoreModule, sem rotas).
    ChatLauncherModule,
  ],
  providers: [MenuService],
})
export class LayoutsModule {}
